import { createPortal } from "react-dom";
import useTooltip from "../../../../../../../hooks/useTooltip";

const TOOLTIP_WIDTH = 400;
const TOOLTIP_MAX_HEIGHT = 300;

export const removeBlankLines = (text = "") =>
  text.replace(/(\r?\n[ \t]*){2,}/g, "\n").trim();

const ConditionDescription = props => {
  const description = props.row?.description || "";
  const { showTooltip, tooltipPos, handleMouseEnter, handleMouseLeave } =
    useTooltip({
      tooltipWidth: TOOLTIP_WIDTH,
      tooltipHeight: TOOLTIP_MAX_HEIGHT,
    });

  // the portal is a React child of this wrapper, so moving the mouse onto the
  // tooltip to scroll it does not trigger onMouseLeave. The empty title stops
  // any ancestor's native title tooltip appearing alongside this one.
  return (
    <div
      title=""
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="line-clamp-3 w-[400px] cursor-pointer whitespace-pre-line break-words">
        {removeBlankLines(description)}
      </div>
      {showTooltip &&
        tooltipPos &&
        description &&
        createPortal(
          <div
            className="fixed z-50 overflow-y-auto whitespace-pre-wrap break-words rounded-md bg-[#333] p-2 text-sm text-white shadow-xl"
            style={{
              ...tooltipPos,
              width: TOOLTIP_WIDTH,
              maxHeight: TOOLTIP_MAX_HEIGHT,
            }}
          >
            {description}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default ConditionDescription;
